window.$ = window.jQuery = require('jquery');

require('jquery-mask-plugin');
require('imagesloaded');

$.ajaxSetup({
  headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
  }
});

/**
 * Modal jQ plugin
 */
(function( $ ) {
  
  $.fn.modal = function(action)
  {

      if (action === "show")
        $(this).removeClass("hidden");

      if (action === "hide") 
        $(this).addClass("hidden");

  };

}( jQuery ));

// jQuery
jQuery(function()
{

  // Void click
  $("body").on("click", "[data-void]", function(e)
  {
    e.preventDefault();
  });

});